// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: M94oJWBrxO

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSurpriseModeIcon.module.css"; // plasmic-import: M94oJWBrxO/css

createPlasmicElementProxy;

export type PlasmicSurpriseModeIcon__VariantMembers = {
  selected: "selected";
  color: "blue" | "red";
};
export type PlasmicSurpriseModeIcon__VariantsArgs = {
  selected?: SingleBooleanChoiceArg<"selected">;
  color?: SingleChoiceArg<"blue" | "red">;
};
type VariantPropType = keyof PlasmicSurpriseModeIcon__VariantsArgs;
export const PlasmicSurpriseModeIcon__VariantProps = new Array<VariantPropType>(
  "selected",
  "color"
);

export type PlasmicSurpriseModeIcon__ArgsType = {};
type ArgPropType = keyof PlasmicSurpriseModeIcon__ArgsType;
export const PlasmicSurpriseModeIcon__ArgProps = new Array<ArgPropType>();

export type PlasmicSurpriseModeIcon__OverridesType = {
  root?: p.Flex<"button">;
  freeBox?: p.Flex<"div">;
};

export interface DefaultSurpriseModeIconProps {
  selected?: SingleBooleanChoiceArg<"selected">;
  color?: SingleChoiceArg<"blue" | "red">;
  className?: string;
}

const $$ = {};

function PlasmicSurpriseModeIcon__RenderFunc(props: {
  variants: PlasmicSurpriseModeIcon__VariantsArgs;
  args: PlasmicSurpriseModeIcon__ArgsType;
  overrides: PlasmicSurpriseModeIcon__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.selected
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <p.Stack
      as={"button"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootselected]: hasVariant($state, "selected", "selected"),
          [sty.rootselected_color_red]:
            hasVariant($state, "selected", "selected") &&
            hasVariant($state, "color", "red")
        }
      )}
    >
      <p.PlasmicImg
        alt={""}
        className={classNames(sty.img___8Qfct, {
          [sty.imgselected___8QfctOeozy]: hasVariant(
            $state,
            "selected",
            "selected"
          ),
          [sty.imgselected_color_red___8QfctOeozyRz9PY]:
            hasVariant($state, "selected", "selected") &&
            hasVariant($state, "color", "red")
        })}
        displayHeight={"auto"}
        displayMaxHeight={"none"}
        displayMaxWidth={"none"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={"50px"}
        loader={"plasmic"}
        loading={"lazy"}
        src={{
          src: "https://site-assets.plasmic.app/5448c90771e2617d9134af4c0a61bb52.svg",
          fullWidth: 133,
          fullHeight: 150,
          aspectRatio: 0.887574
        }}
      />

      {(
        hasVariant($state, "selected", "selected") &&
        hasVariant($state, "color", "red")
          ? true
          : hasVariant($state, "color", "red")
          ? false
          : hasVariant($state, "selected", "selected")
          ? true
          : true
      ) ? (
        <p.PlasmicImg
          alt={""}
          className={classNames(sty.img__achw4, {
            [sty.imgcolor_blue__achw41NCds]: hasVariant(
              $state,
              "color",
              "blue"
            ),
            [sty.imgcolor_red__achw4Rz9PY]: hasVariant($state, "color", "red"),
            [sty.imgselected__achw4Oeozy]: hasVariant(
              $state,
              "selected",
              "selected"
            ),
            [sty.imgselected_color_red__achw4OeozyRz9PY]:
              hasVariant($state, "selected", "selected") &&
              hasVariant($state, "color", "red")
          })}
          displayHeight={"35px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"35px"}
          loader={"plasmic"}
          src={{
            src: "https://site-assets.plasmic.app/6f07936064e75aee6bbfade85d2df054.svg",
            fullWidth: 80,
            fullHeight: 100,
            aspectRatio: 0.792079
          }}
        />
      ) : null}
      {(
        hasVariant($state, "selected", "selected") &&
        hasVariant($state, "color", "red")
          ? true
          : hasVariant($state, "color", "red")
          ? true
          : hasVariant($state, "selected", "selected")
          ? true
          : false
      ) ? (
        <p.PlasmicImg
          alt={""}
          className={classNames(sty.img___1Gc0L, {
            [sty.imgcolor_red___1Gc0Lrz9PY]: hasVariant($state, "color", "red"),
            [sty.imgselected___1Gc0LOeozy]: hasVariant(
              $state,
              "selected",
              "selected"
            ),
            [sty.imgselected_color_red___1Gc0LOeozyRz9PY]:
              hasVariant($state, "selected", "selected") &&
              hasVariant($state, "color", "red")
          })}
          displayHeight={"35px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"35px"}
          loader={"plasmic"}
          src={{
            src: "https://site-assets.plasmic.app/55be51138926d075a6d22be275514019.svg",
            fullWidth: 80,
            fullHeight: 100,
            aspectRatio: 0.792079
          }}
        />
      ) : null}
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxselected]: hasVariant($state, "selected", "selected"),
          [sty.freeBoxselected_color_red]:
            hasVariant($state, "selected", "selected") &&
            hasVariant($state, "color", "red")
        })}
      />
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSurpriseModeIcon__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSurpriseModeIcon__VariantsArgs;
    args?: PlasmicSurpriseModeIcon__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSurpriseModeIcon__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSurpriseModeIcon__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSurpriseModeIcon__ArgProps,
          internalVariantPropNames: PlasmicSurpriseModeIcon__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSurpriseModeIcon__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSurpriseModeIcon";
  } else {
    func.displayName = `PlasmicSurpriseModeIcon.${nodeName}`;
  }
  return func;
}

export const PlasmicSurpriseModeIcon = Object.assign(
  // Top-level PlasmicSurpriseModeIcon renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicSurpriseModeIcon
    internalVariantProps: PlasmicSurpriseModeIcon__VariantProps,
    internalArgProps: PlasmicSurpriseModeIcon__ArgProps
  }
);

export default PlasmicSurpriseModeIcon;
/* prettier-ignore-end */
